import WithResponsiveRendering from "@/modules/common/components/wrappers/with-responsive-rendering";
import CommonModal, { CommonModalProps } from "./common-modal";
import MobileModal, { MobileModalProps } from "./mobile-modal";
import { useMemo } from "react";

// Use intersection of both prop types for full flexibility
export type ResponsiveModalProps = CommonModalProps & MobileModalProps;

const ResponsiveModal = (props: ResponsiveModalProps) => {
  const Responsive = useMemo(
    () =>
      WithResponsiveRendering<ResponsiveModalProps>({
        MobileComponent: MobileModal,
        DesktopComponent: CommonModal,
      }),
    []
  );
  return <Responsive {...props} />;
};

export default ResponsiveModal;
